// Service layer for the AyushPay Loan Subscribers module.
// Wired to the loan backend (internalapi v4, ops + superadmin).

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getApiRole = (uiRole) => {
  const roleMapping = {
    SuperAdmin: 'superadmin',
    Finance: 'finance',
    Ops: 'ops',
    Support: 'support',
  };
  return roleMapping[uiRole] || 'ops';
};

const makeRequest = async (endpoint, options = {}) => {
  const token = localStorage.getItem('authToken');
  if (!token) {
    throw new Error('No authentication token found. Please login first.');
  }

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 12000);

  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: options.method || 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      body: options.body,
      signal: controller.signal,
    });

    if (!response.ok) {
      const errorText = await response.text();
      let errorMessage = errorText || 'Unknown API error';
      try {
        const parsed = JSON.parse(errorText);
        if (Array.isArray(parsed?.msg)) {
          errorMessage = parsed.msg.map((m) => m.value).filter(Boolean).join(' ') || errorText; // ok
        } else {
          errorMessage = parsed?.msg?.error || parsed?.msg?.status || errorText;
        }
      } catch {
        // keep raw text
      }
      throw new Error(errorMessage);
    }

    return response.json();
  } catch (error) {
    if (error.name === 'AbortError') {
      throw new Error('Request timeout. Please try again.');
    }
    throw error;
  } finally {
    clearTimeout(timeoutId);
  }
};

export const getLoanSubscribersList = async (role, params = {}) => {
  const apiRole = getApiRole(role);
  const qs = new URLSearchParams();

  if (params.page) qs.set('page', params.page);
  if (params.items) qs.set('items', params.items);
  if (params.search) qs.set('search', params.search);
  if (params.journey_type) qs.set('journey_type', params.journey_type);

  const query = qs.toString();
  return makeRequest(`/internal/apis/v4/${apiRole}/loan-subscribers/list/${query ? `?${query}` : ''}`);
};

export const getLoanSubscriberDetail = async (role, applicationId) => {
  const apiRole = getApiRole(role);
  return makeRequest(`/internal/apis/v4/${apiRole}/loan-subscribers/${applicationId}/detail/`);
};
